import React, { useState } from 'react';
import { Box } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import { Section, InputField, Loading } from '../components';
import { ReactComponent as IconKey } from '../assets/cb-api-key-icon.svg';

function KnowledgeBaseConfig(props) {
  const {
    data, resetConfig, saveConfig, isFetchingConfig,
  } = props;

  const [kbApiKey, setKbApiKey] = useState(data.conversationBuilderToken);

  const handleTokenChange = (e) => {
    setKbApiKey(e.target.value);
  };

  const handleSaveConfig = () => {
    saveConfig({
      conversationBuilderToken: kbApiKey,
    });
  };

  const handleResetConfig = () => {
    setKbApiKey(data.conversationBuilderToken);
    resetConfig();
  };

  return (
    <Section
      data-testid="kb-config"
      title="Add KB"
      subtitle={(
        <Box display="inline-flex" flexWrap="wrap" alignItems="center">
          <span>
            Connect available knowledge bases to Agent Assist by copying the
            API Access Key from Knowledge Base application -&gt;
          </span>
          <span><Box ml={1} mr={1} display="inline-flex" justifyContent="center" alignItems="center"><IconKey /></Box></span>
          <span>
            -&gt; API Details and pasting it here.
          </span>
        </Box>
      )}
    >
      <Box style={{ maxWidth: 500 }}>
        {kbApiKey === null ? <Loading size={24} data-testid="loading-kb-config" /> : (
          <InputField
            value={kbApiKey}
            handleChange={handleTokenChange}
            inputType="InputField"
            label="API Access Key"
            cancel={handleResetConfig}
            save={handleSaveConfig}
            data-testid={`api-access-key${isFetchingConfig ? '-fetching' : ''}`}
          />
        )}
      </Box>
    </Section>
  );
}

KnowledgeBaseConfig.defaultProps = {
  data: null,
};

KnowledgeBaseConfig.propTypes = {
  isFetchingConfig: PropTypes.bool.isRequired,
  resetConfig: PropTypes.func.isRequired,
  saveConfig: PropTypes.func.isRequired,
  data: PropTypes.object,
};

export default KnowledgeBaseConfig;
